<template>
  <div class="">
    <form @submit.prevent="onSubmit">

      <b-form-row>

        <form-group class="my-2 col-lg-12" :validations="$v.form.q_1">
          <div slot-scope="{ errors, invalid }">
            <label>شروع بازه</label>

            <input v-model="form.q_1" type="text" class="form-control">

            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

        <form-group class="my-2 col-lg-12" :validations="$v.form.q_2">
          <div slot-scope="{ errors, invalid }">
            <label>پایان بازه</label>

            <input v-model="form.q_2" type="text" class="form-control">

            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

        <form-group class="my-2 col-lg-12" :validations="$v.form.price">
          <div slot-scope="{ errors, invalid }">
            <label>قیمت</label>

            <input v-model="form.price" type="text" class="form-control">

            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

        <form-group class="my-2 col-lg-12" :validations="$v.form.offer">
          <div slot-scope="{ errors, invalid }">
            <label>تخفیف</label>

            <input v-model="form.offer" type="text" class="form-control">

            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

        <form-group class="my-2 col-lg-12" :validations="$v.form.step">
          <div slot-scope="{ errors, invalid }">
            <label>پله</label>

            <input v-model="form.step" type="text" class="form-control">

            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>


      </b-form-row>


      <b-button class="w-100 my-2" pill type="submit">ثبت</b-button>

    </form>
  </div>
</template>

<script>
import FormGroup from "../../validator/FormGroup.vue";
import FormErrorsManager from "../../validator/FormErrorsManager.vue";
import {required, numeric} from "vuelidate/lib/validators";

export default {
  name: "BulkForm",
  components: {
    FormGroup,
    FormErrorsManager,
  },
  props: {
    bulk: {
      default: null
    },
    product_id: {},
  },
  data() {
    return {
      form: {
        link: '',
        xpath: '',
        crawlerable_column: '',
      },
    }
  },
  computed: {
    isInUpdateMode() {
      return this.bulk !== null
    }
  },
  validations: {
    form: {
      q_1: {required, numeric},
      q_2: {numeric},
      price: {required, numeric},
      offer: {required, numeric},
      step: {numeric}
    },
  },
  methods: {
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {
      if (this.invalid()) {

        const form = {
          id: this.form.id,
          product_id: this.product_id,
          q_1: this.form.q_1,
          q_2: this.form.q_2,
          price: this.form.price,
          offer: this.form.offer,
          step: this.form.step === '' || this.form.step == null ? 1 : this.form.step,
          sub_product: null, // todo dynamic this section for support variable product
        }


        if (this.isInUpdateMode) {
          this.$store.dispatch('Bulk/updateBulk', form)
        } else {
          this.$store.dispatch('Bulk/createBulks', form)
        }


      }
    },
  },
  mounted() {
    if (this.bulk != null) {
      this.form = {...this.bulk, step: this.bulk.step == null || this.bulk.step === '' ? 1 : this.bulk.step}
    } else {
      this.form = {
        q_1: '',
        q_2: '',
        price: '',
        offer: '',
        step: 1,
      }
    }
  }
}
</script>

<style scoped>

</style>